import type { ReactNode } from 'react';

type Props = {
  title: string;
  description?: ReactNode;
  badge?: string;
  error?: string | null;
  message?: string | null;
  children: ReactNode;
  footer?: ReactNode;
};

export function AfSettingsSection({ title, description, badge, error, message, children, footer }: Props) {
  return (
    <section className="af-settings-card">
      <header className="af-settings-card__header">
        <div>
          <h2 className="af-settings-card__title">{title}</h2>
          {description ? <p className="af-settings-card__lead">{description}</p> : null}
        </div>
        {badge ? <span className="af-settings-card__badge">{badge}</span> : null}
      </header>

      {error ? <p className="alert alert-error af-settings-card__alert">{error}</p> : null}
      {message ? <p className="alert alert-success af-settings-card__alert">{message}</p> : null}

      <div className="af-settings-card__body">{children}</div>

      {footer ? <footer className="af-settings-card__footer">{footer}</footer> : null}
    </section>
  );
}
